import { Component } from 'react'
import {
  Box,
  Button,
  Icons,
  Input,
  List,
  Page,
  SimpleReadingListRow,
  SimpleReadingStartInput
} from 'stylewhere/components'
import { Router, FormSchemaData, SimpleReadingListOperationConfig } from 'stylewhere/shared'
import { showToastError } from 'stylewhere/utils'
import { SimpleReadingLists, SimpleReadingList } from 'stylewhere/api'
import { T, __ } from 'stylewhere/i18n'
import { SimpleReadingListExtensions } from 'stylewhere/extensions'

export interface Props {
  operation: SimpleReadingListOperationConfig
  onSelect: (data: SimpleReadingList) => void
  onCreate: (formData: FormSchemaData, operation: SimpleReadingListOperationConfig, schema) => void
}

interface State {
  list?: SimpleReadingList[]
  search?: string
  loading: boolean
  creating: boolean
  page: number
  totalPages: number
  totalElements: number
  loadingData: boolean
}

const PAGE_SIZE = 25

export class SimpleReadingStartListAndInput extends Component<Props> {
  state: State = {
    list: undefined,
    search: undefined,
    loading: true,
    creating: false,
    page: 0,
    totalPages: 0,
    totalElements: 0,
    loadingData: false
  }

  isModal = false
  operation: SimpleReadingListOperationConfig

  constructor(props: Props) {
    super(props)
    this.operation = props.operation
  }

  componentDidMount() {
    this._init()
  }

  _init = async () => {
    await this.loadData()
  }

  loadData = () => {
    this.setState({ loading: true }, this.load)
  }

  changeSearch = (search: string) => {
    this.setState({ loading: true, search, page: 0, list: [] }, this.load)
  }

  loadMore = () => {
    this.setState({ loadingData: true, page: this.state.page + 1 }, this.load)
  }

  load = async () => {
    const { operation } = this.props
    const { page, search, list } = this.state
    try {
      const tmp = list ?? []
      const res = await SimpleReadingLists.getSimpleReadingLists({
        size: PAGE_SIZE,
        page,
        operationId: operation.id,
        codes: search ? search : undefined,
        statuses: ['CREATED', 'STARTED']
      })

      this.setState({
        list: tmp.concat(res.content ?? []),
        totalPages: res.totalPages,
        totalElements: res.totalElements,
        loading: false,
        loadingData: false
      })
    } catch (error) {
      showToastError(error, __(T.error.error), this.isModal)
      this.setState({ list: [], loading: false, loadingData: false })
    }
  }

  onRowClick = (asn: SimpleReadingList) => this.props.onSelect(asn)

  renderSimpleReadingList = (data: SimpleReadingList) => {
    return <SimpleReadingListRow simpleReadingList={data} onClick={() => this.onRowClick(data)} />
  }

  managerCreating = () => {
    const { operation, onCreate } = this.props
    const schema = SimpleReadingListExtensions.formSchema(operation)
    if (schema.length === 0) {
      onCreate({}, operation, schema)
      return
    }
    this.setState({ creating: !this.state.creating })
  }

  addCreateButton = () => {
    const { operation } = this.props
    return !operation.hasChecklist && operation.showListOnStart
  }

  render() {
    const { list, loading, creating, loadingData, totalElements, totalPages, page } = this.state
    const { operation, onCreate } = this.props
    const operationType = operation.type.toLowerCase()
    const withCreateButton = this.addCreateButton()
    return (
      <Page
        title={`${operation.description ?? operationType}`}
        onBackPress={() => {
          creating ? this.managerCreating() : Router.navigate('/')
        }}
      >
        {!creating ? (
          <Page.Content notBoxed>
            <Box p={5} pb={0} mb={20} row justify={'space-between'}>
              <Input
                onChange={this.changeSearch}
                placeholder={__(T.misc.code)}
                image={<Icons.Barcode />}
                style={{ width: 325 }}
                autoFocus
                debounce={500}
              />
              {!withCreateButton && <Box />}
              {withCreateButton && <Button title={__(T.misc.new)} onClick={this.managerCreating} />}
            </Box>
            <Box p={5} flex={1} mt={0}>
              <List
                loading={loading}
                data={list}
                rowRender={this.renderSimpleReadingList}
                loadMore={this.loadMore}
                isNextPageLoading={loadingData}
                stopLoadMore={page === totalPages - 1}
              />
            </Box>
          </Page.Content>
        ) : (
          <SimpleReadingStartInput operation={this.operation} onCreate={onCreate} />
        )}
      </Page>
    )
  }
}
